'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VideoForm = require('./components/VideoForm');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VideoForm).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/video-form/index.js
// module id = 582
// module chunks = 4